var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkModeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.307 5.60357C10.1059 5.73735 8.96703 6.20752 8.0214 6.95997C7.07576 7.71241 6.36178 8.71656 5.96164 9.85685C5.56149 10.9971 5.49143 12.2273 5.75953 13.4056C6.02762 14.584 6.62297 15.6627 7.47707 16.5176C8.33116 17.3726 9.40929 17.969 10.5874 18.2383C11.7655 18.5075 12.9957 18.4387 14.1364 18.0397C15.2771 17.6407 16.282 16.9278 17.0354 15.9829C17.7888 15.038 18.2601 13.8996 18.3951 12.6987C18.4103 12.5643 18.387 12.4283 18.3278 12.3067C18.2686 12.185 18.176 12.0827 18.0609 12.0117C17.9458 11.9406 17.8128 11.9038 17.6775 11.9055C17.5422 11.9072 17.4102 11.9474 17.2969 12.0213C16.5587 12.4932 15.6816 12.6993 14.8105 12.6055C13.9393 12.5117 13.1263 12.1236 12.5055 11.5053C11.8847 10.887 11.4933 10.0755 11.396 9.20472C11.2986 8.33398 11.5012 7.45608 11.9701 6.71598C12.0472 6.60361 12.0904 6.47152 12.0948 6.33534C12.0991 6.19915 12.0643 6.06458 11.9946 5.94755C11.9248 5.83051 11.8229 5.73592 11.7011 5.67496C11.5792 5.614 11.4425 5.58923 11.307 5.60357Z",
    fill: "#040340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeActive);
export default __webpack_public_path__ + "static/media/dark_mode_active.e1971ad300fbf2ac0600fedb1967792d.svg";
export { ForwardRef as ReactComponent };